import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import purify, { SAFE_HTML_ADD_TAGS, SAFE_HTML_ADD_ATTR } from "@/utils/safe-html-purify";


export default /*@__PURE__*/_defineComponent({
  __name: 'SafeHtml',
  props: {
    html: {},
    tag: { default: "div" }
  },
  setup(__props: any) {

const props = __props;

const safeHtml = computed(() => {
  if (!props.html) return "";
  return purify.sanitize(props.html, {
    ADD_TAGS: SAFE_HTML_ADD_TAGS,
    ADD_ATTR: SAFE_HTML_ADD_ATTR,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), { innerHTML: safeHtml.value }, null, 8, ["innerHTML"]))
}
}

})